<div class="slack-oauth-container">
  <h2>Slack OAuth</h2>
  <p>Processing Slack authorization...</p>
  <!-- TODO: Add Slack OAuth handling UI -->
</div> 